import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Company } from '../../model/user/Company';

export interface IClientSlice {
    selectedSupplier?: Company;
}

const initialState: IClientSlice = {
    selectedSupplier: undefined,
};

export const clientSlice = createSlice({
    name: 'client',
    initialState,
    reducers: {
        setSelectedSupplier: (state, action: PayloadAction<Company | undefined>) => {
            state.selectedSupplier = action.payload;
        },
        deselectSupplier: state => {
            state.selectedSupplier = undefined;
        },
    },
});

export const { setSelectedSupplier, deselectSupplier } = clientSlice.actions;
